import _ from 'lodash';
import { createSelector } from 'reselect';

import RefData from '../../ref-data';

import DisplayUnitCollection from './display-unit-collection';
import Experience from '../experience';

const _scopedState = state => state.entities.displayUnit;
const displayUnitsById = state => _scopedState(state).byId;

const displayUnitById = createSelector([displayUnitsById, (state, displayUnitId) => displayUnitId], (du, id) => du[id]);

const displayUnits = createSelector(displayUnitsById, displayUnitsById =>
  _.sortBy(_.values(displayUnitsById), ['isResponsive', 'dimensions'])
);

const displayUnitsByContainerType = createSelector(
  [displayUnits, (state, containerTypeRef) => containerTypeRef],
  (displayUnits, containerTypeRef) => {
    const ret = _.filter(displayUnits, du => {
      return du.typeRef.id === containerTypeRef;
    });
    return ret;
  }
);

const hasFetched = state => _scopedState(state).hasFetched;
const isFetching = state => _scopedState(state).isFetching;

export default {
  displayUnits,
  displayUnitById,
  displayUnitsById,
  hasFetched,
  isFetching,
  displayUnitsByContainerType,
};
